import _ from 'lodash'
import { formatSeoMetaLocation } from './location'

const defaultTitleTemplate =
  'Auction.com: Real Estate Auctions for Foreclosures and Bank Owned Properties'
const defaultMetaDescriptionTemplate =
  'Browse and buy exclusive foreclosure and bank-owned home listings with the convenience of an app. Auction.com is your home base for investing in real estate.'

const fillTemplate = (template, obj) =>
  template.replace(/\${(.*?)}/g, (x, g) => obj[g])

export const getTitle = (filters, titleTag = {}) => {
  if (_.isEmpty(titleTag)) {
    return defaultTitleTemplate
  }
  const seoLocation = formatSeoMetaLocation(filters)
  if (seoLocation === 'US') {
    return defaultTitleTemplate
  } else {
    return fillTemplate(titleTag.title, { seoLocation })
  }
}

export const getDescription = (filters, descriptionTag = {}) => {
  if (_.isEmpty(descriptionTag)) {
    return defaultMetaDescriptionTemplate
  }
  const seoLocation = formatSeoMetaLocation(filters)
  if (seoLocation === 'US') {
    return defaultMetaDescriptionTemplate
  } else {
    return fillTemplate(descriptionTag.description, { seoLocation })
  }
}

export const getAddressKeyTerms = filters => {
  const keyterms = []
  const [state] = filters.state
  const [county] = filters.county
  const [city] = filters.city
  if (state) keyterms.push(state)
  if (county) keyterms.push(county)
  if (city) keyterms.push(city)
  return keyterms
}

export const getAddressFilters = filters => {
  const hasCity = _.get(filters, 'city[0]')
  const hasCounty = _.get(filters, 'county[0]')
  const hasState = _.get(filters, 'state[0]')

  return {
    ...(hasState && { state: filters.state[0] }),
    ...(hasCity && { city: filters.city[0] }),
    ...(hasCounty && { county: `${filters.county[0]} County` }),
  }
}
